import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Divider,
  List,
  ListItem,
  ListItemText,
  Button,
  ListItemSecondaryAction,
  Typography
} from '@material-ui/core';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

const DuplicateReferenceErrorList = ({
  open = false,
  handleClose = () => null,
  duplicates = []
}) => {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle id="form-dialog-title" disableTypography>
        <Typography variant="h4" color="textSecondary">
          Duplicates
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: 0 }}>
        <List aria-labelledby="nested-list-subheader" disablePadding>
          {duplicates.map(({ jid, Name, RefNo, JCd }) => (
            <ListItem
              button
              component="a"
              href={'/app/trans/' + jid}
              target="_blank"
              key={jid}
              divider
            >
              <ListItemText
                primary={Name}
                secondary={`${JCd} | ${RefNo}`}
                primaryTypographyProps={{
                  variant: 'body1'
                }}
                secondaryTypographyProps={{
                  variant: 'body2'
                }}
              />
              <ListItemSecondaryAction>
                <OpenInNewOutlinedIcon fontSize="inherit" />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          size="small"
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateReferenceErrorList;
